import React from 'react'
import PropTypes from 'prop-types'
import Comment from './Comment'
import connectPropTypes from '../utilities/connectPropTypes'
import serverTimestamp from '../utilities/Data/serverTimestamp'
import urlForPostComment from '../utilities/urlForPostComment'
import styles from './FeedPostComment.icss'
import AddButton from './AddButton'

class FeedPostComment extends React.Component {
	render() {
		const { showAddButton, myPost: post } = this.props
		post.countComments = post.countComments || 0

		const captionComment = post && post.caption && {
			text: post.caption,
			createdTimestamp: serverTimestamp(post.createdTimestamp),
			userName: post.userName,
			isPostCaption: true
		}

		return (
			<>
				{captionComment && <Comment comment={captionComment} clamped />}
				{showAddButton && (
					<div className={styles.commentDetails}>
						<div className={styles.buttonSurround}>
							<AddButton onClick={() => this.props.appRedirect(urlForPostComment({ postId: post.postId, params: { addComment: true } }))}>
								{this.context.translate('Add comment')}
							</AddButton>
						</div>
					</div>
				)}
			</>
		)
	}
}

FeedPostComment.contextTypes = {
	translate: PropTypes.func
}

FeedPostComment.propTypes = {
	myPost: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	showAddButton: PropTypes.bool,
	appRedirect: PropTypes.func.isRequired
}

FeedPostComment.defaultProps = {
	myPost: undefined,
	showAddButton: true
}

export const testing = {
	FeedPostComment
}

export default connectPropTypes(FeedPostComment)



// WEBPACK FOOTER //
// ./src/components/FeedPostComment.jsx